import { Route } from '@angular/router';
import { initialDataResolver } from 'app/app.resolvers';
import { AuthGuard } from 'app/core/auth/guards/auth.guard';
import { NoAuthGuard } from 'app/core/auth/guards/noAuth.guard';
import { LayoutComponent } from 'app/layout/layout.component';
import { ServiceLoginComponent } from 'app/modules/auth/service-login/service-login.component';

// @formatter:off
/* eslint-disable max-len */
/* eslint-disable @typescript-eslint/explicit-function-return-type */
export const appRoutes: Route[] = [

    // Redirect empty path to '/dashboards/analytics'
    {path: '', pathMatch : 'full', redirectTo: 'dashboards/account'},

    // Redirect signed-in user to the '/dashboards/analytics'
    //
    // After the user signs in, the sign-in page will redirect the user to the 'signed-in-redirect'
    // path. Below is another redirection for that path to redirect the user to the desired
    // location. This is a small convenience to keep all main routes together here on this file.
    {path: 'signed-in-redirect', pathMatch : 'full', redirectTo: 'dashboards/account'},

    {
        path: 'ServiceLogin', 
        component: ServiceLoginComponent,
        data: {
            layout: 'empty'
        },
    },

    // Auth routes for guests
    {
        path: '',
        canActivate: [NoAuthGuard],
        canActivateChild: [NoAuthGuard],
        component: LayoutComponent,
        data: {
            layout: 'empty'
        },
        children: [
            {path: 'confirmation-required', loadChildren: () => import('app/modules/auth/confirmation-required/confirmation-required.routes')},
            {path: 'forgot-password', loadChildren: () => import('app/modules/auth/forgot-password/forgot-password.routes')},
            {path: 'reset-password', loadChildren: () => import('app/modules/auth/reset-password/reset-password.routes')},
            {path: 'sign-in', loadChildren: () => import('app/modules/auth/sign-in/sign-in.routes')},
            {path: 'sign-up', loadChildren: () => import('app/modules/auth/sign-up/sign-up.routes')}
        ]
    },

    // Auth routes for authenticated users
    {
        path: '',
        canActivate: [AuthGuard],
        canActivateChild: [AuthGuard],
        component: LayoutComponent,
        data: {
            layout: 'empty'
        },
        children: [
            {path: 'sign-out', loadChildren: () => import('app/modules/auth/sign-out/sign-out.routes')},
            {path: 'unlock-session', loadChildren: () => import('app/modules/auth/unlock-session/unlock-session.routes')}
        ]
    },

    // Landing routes
    {
        path: '',
        component: LayoutComponent,
        data: {
            layout: 'empty'
        },
        children: [
            {path: 'home', loadChildren: () => import('app/modules/landing/home/home.routes')},
            // Error
            {path: 'error', children: [
                {path: '400', loadChildren: () => import('app/modules/error/error-400/error-400.routes')},
                {path: '404', loadChildren: () => import('app/modules/error/error-404/error-404.routes')},
                {path: '500', loadChildren: () => import('app/modules/error/error-500/error-500.routes')}
            ]},
        ]
    },

    // Admin routes
    {
        path: '',
        canActivate: [AuthGuard],
        canActivateChild: [AuthGuard],
        component: LayoutComponent,
        resolve: {
            initialData: initialDataResolver
        },
        children: [
            //Client
            {path: 'projects', loadChildren: () => import('app/modules/admin/apps/builder/builder.routes')},
            
            // Dashboard
            {path: 'dashboards', children: [
                {path: 'account', loadChildren: () => import('app/modules/admin/dashboards/account/account.routes')},
            ]},
            // Apps
            {path: 'apps', children: [
                {path: 'projects', loadChildren: () => import('app/modules/admin/apps/projects/projects.routes')},
                {path: 'templates', loadChildren: () => import('app/modules/admin/apps/templates/templates.routes')},
            ]},

            // Pages
            {path: 'pages', children: [
                {path: 'settings', loadChildren: () => import('app/modules/admin/pages/settings/settings.routes')},

                
            ]},

            {path: 'example', loadChildren: () => import('app/modules/admin/example/example.routes')},
        ]
    }

    



];
